<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle']);
</script>

<template>
  <div>
    <button
      type="button"
      class="flex items-center justify-between w-full gap-2 px-6 py-3"
      @click="emit('toggle')"
    >
      <span class="text-sm font-medium text-n-slate-12">{{ title }}</span>
      <span
        class="transition-transform duration-200 text-n-slate-10 size-4 i-lucide-chevron-down"
        :class="{ 'rotate-180': isOpen }"
      />
    </button>
    <div v-if="isOpen" class="pb-4">
      <slot />
    </div>
  </div>
</template>
